module.exports = __webpack_public_path__ + "img/clipboard-list-solid.2186845f.svg";